<mat-card class="containner">
  <menu-header [menuTopic]="titleTopic"></menu-header>
  <app-user-search-filter
    [roleOptions]="roleOptions"
    [statusOptions]="statusOptions"
    (search)="onSearch($event)"
    (reset)="onReset()"
    (createUser)="openCreate()"
  ></app-user-search-filter>
  <app-user-table
    [rows]="userList"
    (action)="onRowAction($event)"
  ></app-user-table>
</mat-card>
